import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import { architeckCall } from 'database';
import moment from 'moment';
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

const { SearchBar } = Search;

const pagination = paginationFactory({
    sizePerPage: 10,
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
        <div className="dataTables_length" id="datatable-basic_length">
            <label>
                Show{" "}
                {<select
                    name="datatable-basic_length"
                    aria-controls="datatable-basic"
                    className="form-control form-control-sm"
                    onChange={e => onSizePerPageChange(e.target.value)}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>}{" "}
                entries.
            </label>
        </div>
    )
});



class DevelopersPayId extends React.Component {

    state = {
        amount: 0,
        project_logs_developers: [],
        developer_payments: [],
        total_billables: 0,
        developer: {},

    }

    onCreate = async () => {

        const created = await architeckCall({
            method: 'post',
            url: '/api/v1/crud/developer_payments/create/',
            data: {
                amount: this.state.amount * 100,
                user: this.props.viewing_user._id
            }
        });

        if(created.success) {

            this.setState({amount: 0})

            let developer_payments = [...this.state.developer_payments];
            developer_payments.unshift({
                ...created.data,
                user: this.state.developer
            }) 

            this.setState({developer_payments}, () => {
                this.calculateBillables()
            })
            
            
        } else {

            toggleAlert(true, 'danger', 'An error occurred.', 'infinite' )
            console.log(created)

        }

    }



    columnsPayments = [
        {
            dataField: "Developer",
            text: "Minutes",
            sort: true,
            formatter: (cell, row) => row.user.given_name + ' ' + row.user.family_name
        }, 
        {
            dataField: "amount",
            text: "Amount",
            sort: true,
            formatter: (cell, row) => (
            <span>${(row.amount / 100).toFixed(2)}</span>
            )
        }, {
            dataField: "created_at",
            text: "Created On",
            sort: true,
            formatter: (cell, row) => moment.unix(row.created_at).format("MM/DD/YYYY")
        },
    ]

    columns = [
        {
            dataField: "created_at",
            text: "Date",
            sort: true,
            formatter: (cell, row) => moment.unix(row.created_at).format("MM/DD/YYYY")
        },
        {
            dataField: "project",
            text: "Project",
            sort: true,
            formatter: (cell, row) => (
                <Link to={`/developers/projects/${row.project._id}`}>
                    {row.project.name}
                </Link>
            )
        },
        {
            dataField: "description",
            text: "Description",
            sort: true,
            formatter: (cell, row) => (
                <span>
                    {row.description && row.description.length > 30 ? row.description.slice(0,30) + '...' : row.description}
                </span>
            )
        }, {
            dataField: "problems",
            text: "Problems",
            sort: true,
            formatter: (cell, row) => (
                <span>
                    {row.problems && row.problems.length > 15 ? row.problems.slice(0,15) + '...' : row.problems}
                </span>
            )
        }, {
            dataField: "minutes",
            text: "Minutes",
            sort: true,
            formatter: (cell, row) => (
               <span>{row.minutes}</span>
            )
        }, {
            dataField: "cost",
            text: "Billable",
            sort: true,
            formatter: (cell, row) => (
               <span>${(row.cost / 100).toFixed(2)}</span>
            )
        }
    ]

    componentDidMount = async () => {

        let found_user = this.props.app_users.find(u => u._id === this.props.viewing_user._id);

        if(!found_user) {
            this.setState({shouldRedirect: '/admin/developers/pay'});
            return;
        }

        let project_logs_developers = await architeckCall({
            method: 'get',
            url: `/api/v1/project_logs_developers/list?find_by=user__${this.props.viewing_user._id}&loop=true&limit=500`
        })

        let developer_payments = await architeckCall({
            method: 'get',
            url: `/api/v1/developer_payments/list?find_by=user__${this.props.viewing_user._id}&loop=true&limit=500`
        })

        if(project_logs_developers.success && developer_payments.success) {


            this.setState({
                project_logs_developers: project_logs_developers.data, 
                developer: found_user,
                developer_payments: developer_payments.data
            }, () => {

                this.calculateBillables()
            })

        } else {

            toggleAlert(true, 'danger', 'An error occurred fetching your project log data.', 'infinite' )

        }

    }

    calculateBillables = () => {

        let total_billables = 0;
        let total_paid = 0

        this.state.project_logs_developers.forEach(p => {
            if(p.cost) {
                total_billables = total_billables + p.cost;
            }
        })

        this.state.developer_payments.forEach(d => {
            if(d.amount) {
                total_paid = total_paid + d.amount;
            }
        })

        this.setState({
            total_billables, 
            total_paid,
        })

    }

    render() {

        if(this.state.shouldRedirect) {
            return <Redirect to={this.state.shouldRedirect} />
        }

        const developer_payments = this.state.developer_payments

        const amount_owed = ((this.state.total_billables / 100) - (this.state.total_paid / 100)).toFixed(2);

        return (

            <Container>     

                <Helmet>
                    <title>Project Logs All</title>
                    <meta name="description" content="Project Logs All" />
                </Helmet>

                {this.state.deletionAlert}

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers" 
                    title={<span>Dashboard</span>} breadcrumb_1="Project Logs"  
                />

                <Card>

                    <CardBody>
                        <h2 className="mb-0">My Architeck Balance</h2>

                        <Row>
                            <Col md={4}>
                                <p>Total Billables</p>
                                <span className="font-weight-bold ">
                                    ${(this.state.total_billables / 100).toFixed(2)}
                                </span>
                            </Col>
                            <Col md={4} className="text-left text-md-center">
                                
                                <p>Total Paid: </p>
                                <span className="font-weight-bold ">
                                    ${(this.state.total_paid / 100).toFixed(2)}
                                </span>
                            </Col>
                            <Col md={4} className="text-left text-md-right">
                                <p>Next Pay Period</p>
                                <span className="font-weight-bold text-success">
                                    ${amount_owed}
                                </span>
                            </Col>
                        </Row>
                    </CardBody>

                   
                </Card>

                <Card>

                    <CardHeader>
                        <h2 className="mb-0">Past Payments</h2>
                    </CardHeader>

                    <CardBody className="pt-0">
                        <div className="table-vertical-align">
                            <ToolkitProvider
                                data={developer_payments}
                                keyField="_id"
                                columns={this.columnsPayments}
                                search
                                exportCSV
                            >
                            {props => (
                                <div className="py-4 table-responsive table-vertical-align">
                                    <div id="datatable-basic_filter" className="dataTables_filter pr-4 pb-1 pl-0 w-100" >

                                        <label >

                                            <SearchBar  className="form-control-sm ml-0" placeholder="" {...props.searchProps}/>
                                        </label>
                                    </div>

                                    <BootstrapTable 
                                        {...props.baseProps} 
                                        className="xxx" 
                                        bootstrap4={true} 
                                        pagination={pagination} 
                                        bordered={false}
                                    />
                                </div>
                            )}
                            </ToolkitProvider>
                        </div>

                    </CardBody>
                </Card>


            </Container>

        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_projects: state.projects.app_projects,
      app_users: state.users.app_users,

    };
};
  
export default connect(mapStateToProps, '')(DevelopersPayId);